import React, { useCallback, useMemo, useEffect, useState } from 'react'
import { Button, Card, Modal } from 'react-bootstrap'
import ReactTableBootstrap from 'react-table-bootstrap'
import TableActionItems from '../../../components/table-action-items/TableActionItems'
import { doRequestPost } from '../../../api'
import { toast } from 'react-toastify'
import { promiseCatch, doToast, getActions, apiResource, getDate } from '../../../utils'
import { useGet } from '../../../hooks/process-data'
import { SaleForm } from '../sale-form/SaleForm'
import { useSelector } from 'react-redux'
import { FormCustom, Input } from '../../../components/form'

export const SaleView = () => {
  const [data, setData] = useState({
    p_date_start: getDate(),
    p_date_end: getDate()
  })

  const { rows, isProcessing, setReload, error, setError } = useGet({
    url: '/sale/get/' + data.p_date_start + '/' + data.p_date_end,
  })
  const [modalShow, setModalShow] = useState(false)

  const { permissions } = useSelector(store => store.session)
  const actions = getActions({ permissions, module: 'ventas' })
  const [finalPdf, setFinalPdf] = useState('')

  const rowItem = useCallback(({
    row = {},
    type = 'update'
  }) => {
    const rowId = row.id_sale

    return <TableActionItems
      size="lg"
      data={row}
      type={type}
      rowId={rowId}
      formRender={({ modalHide }) => {
        return <SaleForm rowId={rowId} setReload={(response) => {
          setReload(true)
          modalHide()
          setFinalPdf(apiResource({
            url: response.pdf_pos_url
          }))
          setModalShow(true)
        }} />
      }}
      doDelete={async ({ hideAlert, setProcessingAlert }) => {
        try {
          setProcessingAlert(true)
          const deleteRecord = await doRequestPost({
            url: '/sale/delete',
            data: {
              p_id_sale: rowId
            }
          })

          doToast({
            ...deleteRecord,
            toast
          })
          hideAlert()
          setReload(true)
        } catch (error) {
          promiseCatch({
            toast
          })
          setProcessingAlert(false)
        }
      }}
      showCreate={actions?.create}
      showUpdate={actions?.update}
      showDelete={actions?.delete}
    />
  }, [setReload, actions])

  const dtRows = useMemo(() => {
    return <ReactTableBootstrap
      head={[
        [
          {
            name: 'actions', text: <i className="fa fa-cog"></i>, align: 'center', render: row => {
              return <>
                <Button size="xs" variant='danger mr-2' className='text-white' onClick={_ => {
                  setFinalPdf(apiResource({
                    url: row.final_pdf
                  }))
                  setModalShow(true)
                }}>
                  <i className='fa fa-file-pdf'></i>
                </Button>

                <Button size="xs" variant='dark' className='text-white' onClick={_ => {
                  setFinalPdf(apiResource({
                    url: row.pdf_pos_url
                  }))
                  setModalShow(true)
                }}>
                  <i className='fa fa-file-pdf'></i>
                </Button>
              </>
            }
          },
          { name: 'sale_date', text: 'Fecha', align: 'center' },
          { name: 'name_customer', text: 'Nombre', align: 'center' },
          { name: 'last_name_customer', text: 'Apellido', align: 'center' },
          { name: 'phone_customer', text: 'Telefono', align: 'center' },
          { name: 'email_customer', text: 'Email', align: 'center' },
          { name: 'name_format_pay', text: 'Método de Pago', align: 'center' },
          { name: 'name_branch_office', text: 'Sucursal', align: 'center' },
          { name: 'total', text: 'Total', align: 'center' },
          { name: 'username_user', text: 'Creado Por', align: 'center' },
        ]
      ]}
      rows={rows}
      isProcessing={isProcessing}
      orderDirection={'desc'}
      columnOrder={'sale_date'}
      pageLength={50}
    />
  }, [rows, isProcessing])

  useEffect(() => {
    if (error) {
      promiseCatch({
        toast
      })
      setError(false);
    }
  }, [error, setError])


  return <div className='row'>
    <div className="col-12">
      <Card>
        <Card.Body>
          {rowItem({
            type: 'create'
          })}
          <FormCustom textButton="Buscar" onSubmit={() => {
            setReload(true)
          }} viewSubmit={false}>
            <Input
              text="Fecha Inicio"
              classNameParent="col-md-6 mb-3"
              required
              invalid="El campo es obligatorio."
              value={data.p_date_start}
              onChange={e => setData({ ...data, p_date_start: e.target.value })}
              type="date"
            />
            <Input
              text="Fecha Fin"
              classNameParent="col-md-6 mb-3"
              required
              invalid="El campo es obligatorio."
              value={data.p_date_end}
              onChange={e => setData({ ...data, p_date_end: e.target.value })}
              type="date"
              append={[
                <Button
                  type="submit"
                >
                  <i className="fa fa-search"></i>
                </Button>
              ]}
            />
          </FormCustom>
          {dtRows}
        </Card.Body>
      </Card>
      <Modal show={modalShow} onHide={_ => setModalShow(false)} backdrop="static" size="lg">
        <Modal.Header closeButton>
          <Modal.Title as="div">Descargar PDF de la venta</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <iframe src={finalPdf} title="Documento de la venta" width="100%" height="500px"></iframe>
        </Modal.Body>
      </Modal>
    </div>
  </div>
}